import React from "react";
import bannerImg from "assets/images/png/landing-page-img01.png";
import "./style.scss";
import JourneyCards from "components/Cards/journeyCards";

function JourneySection() {
  return (
    <div
      style={{
        backgroundImage: `url(${bannerImg})`,
      }}
      className="journey-section-wrapper"
    >
      <div className="journey-section-content-wrapper container">
        <div className="journey-content">
          <h2 className="journey-title">Your Journey to Love starts with us</h2>
          <div className="journey-sub-content">
            <JourneyCards />
          </div>
        </div>
      </div>
    </div>
  );
}

export default JourneySection;
